<template>
	<div v-if="availableLocations.length" class="relative flex w-fit gap-3">
		<div
			v-for="(loc, index) in availableLocations"
			:key="index"
			class="inline-flex h-6 items-center space-x-1 text-sm text-gray-600"
		>
			<IconLocation class="text-gray-600" />
			<span class="uppercase leading-none">
				{{ formatLocation(loc) }}
			</span>
		</div>
	</div>
	<div v-else-if="location" class="relative flex w-fit">
		<div
			class="inline-flex h-6 items-center space-x-1 text-sm text-gray-600"
		>
			<IconLocation class="text-gray-600" />
			<span class="uppercase leading-none">
				{{ formatLocation(location) }}
			</span>
		</div>
	</div>
</template>

<script setup>
import IconLocation from '@/assets/svg/common/ico-location.svg'

defineProps({
	location: {
		type: String,
		required: true,
	},
	availableLocations: {
		type: Array,
		required: true,
	},
})
</script>
